import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject } from "@/features/maintenance/features/workflows/hooks/establishmentChoice/manualEntryProposals/useMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject";
import { MaintenanceForwardingData } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

interface MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentRejectProps {
  forwarding: MaintenanceForwardingData;
}

const MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject = ({
  forwarding,
}: MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentRejectProps) => {
  const { id } = useParams();

  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const queryClient = useQueryClient();

  const {
    mutate: establishmentReject,
    isPending: establishmentRejectIsPending,
  } = useMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject({
    establishmentChoiceEntryId: forwarding.establishment_choice_entry?.actual_proposal?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflow', id] });
        queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding', forwarding.id] });

        setIsOpen(false);
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({ setMessages })(error);
      },
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            variant="outline-error"
            operationKlassToCheckPermission="Establishment::Maintenance::EstablishmentChoice::ManualEntryProposals::EstablishmentReject"
          >
            Rejeitar processo
          </Button>
        )}
        showClose={false}
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="mt-2 text-white-400"
        useCancellableFooter
        confirmButtonClassName="rounded-br-lg"
        cancelButtonClassName="bg-white-100 rounded-bl-lg"
        confirmButtonIsLoading={establishmentRejectIsPending}
        onConfirm={() => establishmentReject()}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  )
}

export default MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject;
